<div class="pop-tray-wrapper">
    <div #trayWrapper class="pop-menu">

        <div class="pop-content">
            <div class="menu-header-row">
                <div class="menu-header">{{ header }}</div>
                <button
                    type="button"
                    class="tray-close"
                    *ngIf="showCloseButton && actions?.closeFunction"
                    aria-label="Close"
                    (click)="onButtonClick(actions.closeFunction)">
                    x
                </button>
            </div>
            <div class="menu-description" *ngIf="description">{{ description }}</div>
            <ng-content></ng-content>

            <div class="buttons-wrapper">
                <ng-container *ngFor="let b of actions.primaryButtons">
                    <app-primary-btn (click)="onButtonClick(b.function)">
                        {{ b.text }}
                    </app-primary-btn>
                </ng-container>

                <ng-container *ngFor="let b of actions.secondaryButtons">
                    <app-secondary-btn (click)="onButtonClick(b.function)">
                        {{ b.text }}
                    </app-secondary-btn>
                </ng-container>
            </div>
        </div>

    </div>
</div>
